module.exports = {"attributes":{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g opacity=\".9\" fill=\"currentColor\"><path d=\"M.0000517404.714329C.0000517404.319844.319845.0000517413.71433.0000517413H3.57149C3.96597.0000517413 4.28577.319845 4.28577.71433V3.57149C4.28577 3.96597 3.96597 4.28577 3.57149 4.28577H.714329C.319844 4.28577.0000517404 3.96597.0000517404 3.57149V.714329zM5.71429.714278C5.71429.319793 6.03408 0 6.42856 0H9.28572C9.68021 0 10 .319793 10 .714278V3.57144C10 3.96592 9.68021 4.28571 9.28572 4.28571H6.42856C6.03408 4.28571 5.71429 3.96592 5.71429 3.57144V.714278zM5.71429 6.42856C5.71429 6.03408 6.03408 5.71429 6.42856 5.71429H9.28572C9.68021 5.71429 10 6.03408 10 6.42856V9.28572C10 9.68021 9.68021 10 9.28572 10H6.42856C6.03408 10 5.71429 9.68021 5.71429 9.28572V6.42856zM0 6.42856C0 6.03408.319793 5.71429.714278 5.71429H3.57144C3.96592 5.71429 4.28571 6.03408 4.28571 6.42856V9.28572C4.28571 9.68021 3.96592 10 3.57144 10H.714278C.319793 10 0 9.68021 0 9.28572V6.42856z\"/></g>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
